import { absolutePath } from "./absolutePath";

interface UnifiedInboxSupportFnProps {
  attachmentId?: string | number;
  conversationFilters?: {
    channel_type: "all" | "live_chat" | "email" | "human_support";
    status: "all" | "closed" | "solved" | "open";
  };
  conversationId?: string | number;
  id?: string | number;
  params?: Record<string, unknown>;
}

export const unifiedInboxSupport = {
  createHandoff: () => absolutePath("unified_inbox/support/handoffs"),
  listConversations: ({ conversationFilters }: UnifiedInboxSupportFnProps) =>
    absolutePath("unified_inbox/support/conversations", {
      conversation: conversationFilters,
    }),
  showConversation: ({ id }: UnifiedInboxSupportFnProps) =>
    absolutePath(`unified_inbox/support/conversations/${id}`),
  updateConversation: ({ id }: UnifiedInboxSupportFnProps) =>
    absolutePath(`unified_inbox/support/conversations/${id}`),
  markAsRead: ({ id }: UnifiedInboxSupportFnProps) =>
    absolutePath(`unified_inbox/support/conversations/${id}/mark_as_read`),
  leaveQueue: ({ id }: UnifiedInboxSupportFnProps) =>
    absolutePath(`unified_inbox/support/conversations/${id}/leave_queue`),
  unreadConversations: () =>
    absolutePath("unified_inbox/support/conversations/unread_count"),
  createMessage: ({ id }: UnifiedInboxSupportFnProps) =>
    absolutePath(`unified_inbox/support/conversations/${id}/messages`),
  submitConversation: ({ id }: UnifiedInboxSupportFnProps) =>
    absolutePath(
      `unified_inbox/support/conversations/${id}/submit_conversation`,
    ),
  createAttachment: ({ conversationId }: UnifiedInboxSupportFnProps) =>
    absolutePath(
      `unified_inbox/support/conversations/${conversationId}/attachments`,
    ),
  deleteAttachment: ({
    conversationId,
    attachmentId,
  }: UnifiedInboxSupportFnProps) =>
    absolutePath(
      `unified_inbox/support/conversations/${conversationId}/attachments/${attachmentId}`,
    ),
  getAttachments: ({ conversationId, params }: UnifiedInboxSupportFnProps) =>
    absolutePath(
      `unified_inbox/support/conversations/${conversationId}/attachments`,
      params,
    ),
};
